module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-toolbar', {
    staticClass: "md-transparent",
    attrs: {
      "md-elevation": "0"
    }
  }, [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Quick Tourney")]), _vm._v(" "), _c('md-icon', {
    staticClass: "md-size-2x",
    attrs: {
      "md-src": "/static/img/icons/logo.svg"
    }
  })], 1), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('md-list', [_c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.setCurrentView('/publicTournaments')
      }
    }
  }, [_c('md-icon', {
    staticClass: "md-primary"
  }, [_vm._v("public")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Public Tournaments")])], 1), _vm._v(" "), _c('md-list-item', {
    staticClass: "section-header"
  }, [_c('md-icon', [_vm._v("favorite")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Recent Tournaments")])], 1), _vm._v(" "), _vm._l((_vm.favourites), function(x) {
    return _c('md-list-item', {
      key: x.id,
      staticClass: "md-inset",
      on: {
        "click": function($event) {
          _vm.selectTournament(x)
        }
      }
    }, [_c('span', {
      staticClass: "md-list-item-text recent"
    }, [_vm._v(_vm._s(x.name))])])
  }), _vm._v(" "), (_vm.currentUser) ? _c('div', [_c('md-list-item', {
    staticClass: "section-header"
  }, [_c('md-icon', [_vm._v("person")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v(_vm._s(_vm.currentUser.user.name))])], 1), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.showCreateTournamentDialog = true
      }
    }
  }, [_c('md-icon', {
    staticClass: "md-accent"
  }, [_vm._v("add_circle")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Create Tournament")])], 1), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.setCurrentView('/myTournaments')
      }
    }
  }, [_c('md-icon', [_vm._v("domain")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("My Tournaments")])], 1), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.setCurrentView('/myLocations')
      }
    }
  }, [_c('md-icon', [_vm._v("location_on")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("My Locations")])], 1), _vm._v(" "), _c('md-divider')], 1) : _vm._e(), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.setCurrentView('/help')
      }
    }
  }, [_c('md-icon', [_vm._v("help")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Help")])], 1), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.setCurrentView('/contact')
      }
    }
  }, [_c('md-icon', [_vm._v("message")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Contact Us")])], 1), _vm._v(" "), _c('md-list-item', {
    on: {
      "click": function($event) {
        _vm.setCurrentView('/about')
      }
    }
  }, [_c('md-icon', [_vm._v("info")]), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("About")])], 1)], 2), _vm._v(" "), _c('UpsertTournamentDialog', {
    attrs: {
      "show": _vm.showCreateTournamentDialog
    },
    on: {
      "onClose": function($event) {
        _vm.showCreateTournamentDialog = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c558c80","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainMenu.vue
// module id = 459
// module chunks = 1